<template>
  <v-card tile flat>
    <v-toolbar tile card flat dense color="theme_primary" class="white--text">
      <v-spacer></v-spacer>
      <v-toolbar-title class="white-text text-capitalize"
        >Reconciliation</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-side-icon>
        <v-icon color="white">compare_arrows</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-layout row justify-center v-if="loading">
        <v-progress-circular indeterminate color="primary" />
      </v-layout>
      <v-layout justify-center align-center v-else>
        <v-flex v-if="reconciliation">
          <reconciliationShow :bankReconciliation="reconciliation" />
        </v-flex>
        <span class="caption pa-4" v-else>
          <v-icon size="14" class="pr-1" color="primary">info</v-icon>
          {{
            noReconciliationMessage
              ? noReconciliationMessage
              : "This ressource has not been reconciled yet"
          }}
        </span>
      </v-layout>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('closeDialog')" flat color="green">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import SHOW_BANK_RECONCILIATION from "../../../graphql/bank_reconciliations/show.gql";
import reconciliationShow from "./reconciliationShow";

export default {
  name: "reconciliationModal",
  components: {
    reconciliationShow,
  },
  props: {
    bankReconciliationId: {
      type: String,
      required: false,
      default: "",
    },
    noReconciliationMessage: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      reconciliation: null,
    };
  },
  methods: {
    fetchReconciliation() {
      this.loading = true;
      this.sendQuery(SHOW_BANK_RECONCILIATION, {
        id: this.bankReconciliationId,
      })
        .then((data) => {
          this.loading = false;
          this.reconciliation = data.bank_reconciliation;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.bankReconciliationId) this.fetchReconciliation();
  },
  watch: {
    bankReconciliationId() {
      this.reconciliation = null;
      if (this.bankReconciliationId) this.fetchReconciliation();
    },
  },
};
</script>
